module.exports = __webpack_public_path__ + "img/camp02_close.3b946213.png";